"use client"

import { useState } from "react"
import { Copy } from "lucide-react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"

function ReceiveModal({ onClose, selectedToken }) {
  const [copied, setCopied] = useState(false);
  const walletAddress = selectedToken?.walletAddress || "0zklqyx8xj4abc123def456ghi789jkl012mno345pqr678stu901vwx234yz"

  const handleCopy = () => {
    navigator.clipboard.writeText(walletAddress);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Receive Tokens from Your External Wallet</h2>
          <button className="close-button" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="receive-content">
          <div className="qr-code text-center">
            <img
              src={`https://api.qrserver.com/v1/create-qr-code/?size=270x270&data=${walletAddress}`}
              alt="QR Code for Wallet Address"
              className="qr-image mx-auto w-4/12"
            />
          </div>

          <div className="address-section">
            <h3>Your Wallet Address for {selectedToken?.name}</h3>
            <div className="address-display">
              <p className="address-text">{walletAddress}</p>
            </div>
            <div className="text-center flex justify-center">

              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="copy-tooltip">{copied ? "Copied!" : "Copy to clipboard"}</Tooltip>}
              >
                <button className="copy-address-button flex items-center gap-2" onClick={handleCopy}>
                  <Copy /> Copy Address
                </button>
              </OverlayTrigger>
            </div>
          </div>

          <div className="warning-notice">
            <p>
              Only send assets from supported networks. Sending from unsupported networks may result in permanent loss.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReceiveModal
